import React, { ElementType } from 'react';
import { useModalContext } from './ModalContext';
import { X } from 'lucide-react';

interface ModalHeaderProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
    as?: ElementType;
    href?: string;
    closeButtonClass?: string;
}

const ModalHeader = ({ children, className, closeButtonClass, as: Component = "div", ...props }: ModalHeaderProps) => {
    const { onHide, handleModalToggle } = useModalContext();

    return (
        <Component
            {...props}
            className={className ? className : ''}
            onClick={onHide ? onHide : handleModalToggle}
        >
            {children}
            <button
                type="button"
                data-modal-close="closeModal"
                className={`inline-flex items-center justify-center w-8 h-8 rounded-full bg-slate-500/10 dark:bg-white/10 backdrop-blur-sm transition-all duration-200 hover:bg-red-500/15 hover:rotate-90 ${closeButtonClass ? closeButtonClass : ''}`}
            >
                <X className='lucide lucide-x size-4'></X>
            </button>

        </Component>

    );
}

export default ModalHeader;